module.exports = __webpack_public_path__ + "img/组件1.2f483c5f.png";